export default __webpack_public_path__ + "static/pair-icon-dark-593e9eaba19c0688e0c36575fddad507ef2a1778730b743fa2b332d1c31df69f.png";